import { render, staticRenderFns } from "./conf_table.vue?vue&type=template&id=0a515614&scoped=true&"
import script from "./conf_table.vue?vue&type=script&lang=js&"
export * from "./conf_table.vue?vue&type=script&lang=js&"
import style0 from "./conf_table.vue?vue&type=style&index=0&id=0a515614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a515614",
  null
  
)

export default component.exports